// Use the same worker in production and local production-build tests.
export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.register('/custom-sw.js', {scope:'/', updateViaCache:'none'})
    .then(registration => {
      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state !== 'installed') return;
          if (navigator.serviceWorker.controller) config?.onUpdate?.(registration);
          else config?.onSuccess?.(registration);
        };
      };
      // Check on launch, while preserving any checklist already open.
      registration.update().catch(() => {});
    })
    .catch(() => console.warn('The installed app could not check for an update.'));
}

export function unregister() {
  if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistration('/').then(registration => registration?.unregister());
}
